import React from 'react';
import 'rc-tooltip/assets/bootstrap_white.css';

const TooltipBody = ({ body, maxWidth = 250, center = true }) => {
  return (
    <div
      style={{
        wordBreak: 'break-word',
        maxWidth: maxWidth ? `${maxWidth}px` : 'auto',
        textAlign: center ? 'center' : 'auto'
      }}>
      {body}
    </div>
  );
};

export default TooltipBody;
